module.exports = __webpack_public_path__ + "media/images/about-us-img-02-d264a0c0296384db9b7d502a3465eb76.jpg";